module.exports = __webpack_public_path__ + "img/吓.c0d55d10.gif";